import * as React from 'react';

export interface IInputFormLayout {
  left: React.ReactNode;
  right: React.ReactNode;
}

export const InputFormLayout = ({ left, right }: IInputFormLayout) => (
  <div className='row form-group'>
    <div className='col col-12 col-md-3 col-lg-2 text-left text-md-right'>{left}</div>
    <div className='col col-12 col-md-9 col-lg-10'>{right}</div>
  </div>
);
